module.exports = __webpack_public_path__ + "img/Phone 2.f58309c3.jpeg";